import { NAME_SPACE as ns } from './constants';

export const SET_LINE_ID = `${ns} SET_LINE_ID`;

export default { SET_LINE_ID };
